export const BULK_CASE = "Bulk Case";
export const BULK_QUICK_CASE = "Bulk Quick Case";